/**
 * A job description as a list of duties, for display only (the stored text is
 * never changed): split on ";" and on line breaks, each item trimmed, its
 * first letter upper case and a closing "." or ";" dropped; empty items go.
 * Kept identical to `splitJobDescriptionHelper` in
 * `server-hlb/helpers/jobPositionHelpers.js` (a server test checks both).
 *
 * @param {string} text
 * @returns {string[]}
 */
export const splitJobDescription = (text) =>
  String(text ?? '')
    .split(/;|\r\n?|\n/)
    .map((item) => item.trim().replace(/[.;\s]+$/, ''))
    .filter(Boolean)
    .map((item) => item.charAt(0).toUpperCase() + item.slice(1));
